import { cliente } from "../http/cliente";
import type {
  AuditoriaDetalhe,
  EmpresaAuditavel,
  FiltrosTrilha,
  ItemAuditoriaResumo,
} from "./tipos";

/*
 * Fetchers da trilha de auditoria (FE-5 CP-B — ADR 0026).
 *
 * Camada fina sobre o `cliente` HTTP (CP-C): injeta Bearer, trata refresh/401/503
 * e normaliza erro em `ErroHttp`. Estes fetchers NAO tratam erro — propagam a
 * rejeicao do `cliente` para o TanStack Query (hooks em `./hooks`) decidir.
 *
 * `baseURL` do cliente ja e `/api`, entao os paths aqui sao relativos a ela.
 * Toda a auditoria e READ-ONLY (sem POST/PATCH) — apenas `cliente.get`.
 */

/** `GET /api/auditoria/empresas` — empresas auditaveis pelo escopo do usuario. */
export async function buscarEmpresasAuditaveis(): Promise<EmpresaAuditavel[]> {
  const resposta =
    await cliente.get<EmpresaAuditavel[]>("/auditoria/empresas");
  return resposta.data;
}

/**
 * Monta o objeto `params` da consulta da trilha OMITINDO toda chave opcional
 * ausente ou vazia.
 *
 * `limit`/`offset` SEMPRE entram (numeros, default no backend). Os demais
 * (`acao`/`usuario_id`/`data_de`/`data_ate`/`recurso_prefixo`) so entram quando
 * presentes e nao-vazios — nunca enviamos `acao=""` (o backend rejeitaria string
 * vazia onde espera enum/UUID/datetime). `undefined` tambem fica de fora.
 */
function montarParams(filtros: FiltrosTrilha): Record<string, string | number> {
  const params: Record<string, string | number> = {
    limit: filtros.limit,
    offset: filtros.offset,
  };
  if (filtros.acao) params.acao = filtros.acao;
  if (filtros.usuario_id) params.usuario_id = filtros.usuario_id;
  if (filtros.data_de) params.data_de = filtros.data_de;
  if (filtros.data_ate) params.data_ate = filtros.data_ate;
  if (filtros.recurso_prefixo) params.recurso_prefixo = filtros.recurso_prefixo;
  return params;
}

/** `GET /api/empresas/{empresaId}/auditoria` — trilha resumida (array puro). */
export async function buscarTrilha(
  empresaId: string,
  filtros: FiltrosTrilha,
): Promise<ItemAuditoriaResumo[]> {
  const resposta = await cliente.get<ItemAuditoriaResumo[]>(
    `/empresas/${empresaId}/auditoria`,
    { params: montarParams(filtros) },
  );
  return resposta.data;
}

/** `GET /api/empresas/{empresaId}/auditoria/{registroId}` — detalhe mascarado. */
export async function buscarDetalheAuditoria(
  empresaId: string,
  registroId: string,
): Promise<AuditoriaDetalhe> {
  const resposta = await cliente.get<AuditoriaDetalhe>(
    `/empresas/${empresaId}/auditoria/${registroId}`,
  );
  return resposta.data;
}
